import React from "react";
import { Flex, Text } from "atoms";

const variants = {
  unpublished: {
    bg: "rgba(255, 56, 22, 0.1)",
    textColor: "accents.100",
  },
  published: {
    bg: "rgba(12, 98, 92, 0.1)",
    textColor: "accents.200",
  },
  progress: {
    bg: "secondary.50",
    textColor: "secondary.900",
  },
  drafted: {
    bg: "primary.50",
    textColor: "primary.900",
  },
};

export const Chips = ({ variant, title, ...props }) => {
  return (
    <Flex
      w="100%"
      h="auto"
      bg={variants?.[variant]?.bg}
      cursor="pointer"
      px="0.8rem"
      py="0.4rem"
      jC="center"
      aI="center"
      borderRadius="0.8rem"
      {...props}
    >
      <Text
        fontWeight="600"
        color={variants?.[variant]?.textColor}
        fontSize="1.4rem"
        whiteSpace="nowrap"
      >
        {title}
      </Text>
    </Flex>
  );
};
